'use client';

import { c as _c } from "react/compiler-runtime";
import { Item as Section } from 'react-stately';
import { type AccountSettingsFormSection } from '@module/mdrt-org/shared/utils/enums/account-settings-form-section';
import { HashTabsNavigation, type HashTabsNavigationItems } from '@shared/ui-components/hash-tabs-navigation/hash-tabs-navigation';
export const AccountSettingsPageWrapper = t0 => {
  const $ = _c(3);
  const {
    hashTabsNavigationItems,
    initialTabType
  } = t0;
  let t1;
  if ($[0] !== hashTabsNavigationItems || $[1] !== initialTabType) {
    t1 = <HashTabsNavigation initialTabType={initialTabType} items={hashTabsNavigationItems}>{_temp}</HashTabsNavigation>;
    $[0] = hashTabsNavigationItems;
    $[1] = initialTabType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function _temp(t0) {
  const {
    formComponent
  } = t0;
  return <Section>{formComponent && formComponent}</Section>;
}